import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentConfig } from '../shared/interfaces/environment.interface';

@Injectable({
  providedIn: 'root',
})
export class SurveyStatistcsService {
  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;

  getEpcEstimate(goal: string, IR: string, CPI: string, margin: number) {
    const payload = { goal, IR, CPI, margin };
    return this._http.post<any>(
      `${this._baseUrl}/survey-statistcs/epc-estimate`,
      payload
    );
  }

  getEpcPlatform(countryCode: string) {
    return this._http.get<any>(
      `${this._baseUrl}/survey-statistcs/epc-platform/${countryCode}`
    );
  }

  getSurveyActualEpc(surveyId: any) {
    return this._http.get<any>(
      `${this._baseUrl}/survey-statistcs/epc-actual/${surveyId}`
    );
  }
}
